<template>
  <div>
    <DynamicForm
      ref="dynamicForm"
      v-loading="loading"
      :computed-data="{}"
      :form-list="c_formProperties"
      :is-show="isShow"
      class="dynamicForm"
      v-bind="$attrs"
    />
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import DynamicForm from '@/components/DynamicFormV2.vue';
import { cloneDeep } from 'lodash';
import { mainFormProperties } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/properties';

export default {
  name: 'FinishedProductAndMaterialOrderMainForm',
  components: { DynamicForm },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: ['shareData'],
  data() {
    return {
      formProperties: cloneDeep(mainFormProperties),
      loading: false,
      voucher_type: '本地采购'
    };
  },
  watch: {
    'shareData.total_value'(newValue, oldValue) {
      let find = this.formProperties.find(x => x.prop === 'total_value');
      find.model = newValue;
    }
  },
  computed: {
    c_formProperties() {
      this.formProperties.forEach(item => {
        switch (item.prop) {
          case 'order_remarks':
            item.disabled = this.$cookies.get('userInfo').acct_name !== '上海凡爱';
            break;
          case 'contract_amount':
            item.show = this.shareData.isShowBtnAndFields;
            break;
        }
      });
      return this.formProperties;
    }
  },
  created() {
    this.changeProperties();
  },
  methods: {
    async changeProperties() {
      this.loading = true;

      this.loading = false;
    }
  }
};
</script>
